import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../../Images/logo192.png";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../redux/authSlice/authSlice";
import { AuthContext } from "../../../context/AuthContext";
import { ROLES } from "../../../constants/roles";

export default function Aside({ activeAside }) {
  const dispatch = useDispatch();
  const { role, user } = useContext(AuthContext);
  return (
    <>
      <aside className={activeAside ? "active" : ""}>
        <div className="asideInner pt-3 px-2 overflow-hidden">
          <Link to="./">
            <div className="logo d-flex mb-3 ">
              <figure className="me-3 mb-0">
                <img src={Logo} alt="logo" />
              </figure>
              <div>
                <h1 className="h5 mt-1 ">بصمة خبرة</h1>
                <p className="mb-0"> لأدوات الأمن والسلامة </p>
              </div>
            </div>
          </Link>
          <hr />
          <nav className="asideNav">
            <ul className=" pb-3">
              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/">
                    <i className="fa-solid fa-house"></i>
                    <span>الرئيسية</span>
                  </NavLink>
                </li>
              )}
              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/MaintenanceItems">
                    <i className="fas fa-tools"></i>
                    <span>عناصر الصيانة</span>
                  </NavLink>
                </li>
              )}
              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/allMaintenanceType">
                    <i className="fas fa-tools"></i>
                    <span>انواع الصيانة</span>
                  </NavLink>
                </li>
              )}
              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/allContractTerms">
                    <i className="fas fa-tools"></i>
                    <span>شروط العقد</span>
                  </NavLink>
                </li>
              )}
              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/MaintenanceSchedules">
                    <i className="fas fa-calendar-alt"></i>
                    <span>الجداول</span>
                  </NavLink>
                </li>
              )}

              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/Contracts">
                    <i className="fas fa-file-signature"></i>
                    <span>العقود</span>
                  </NavLink>
                </li>
              )}
              <li>
                <NavLink to="/Tasks">
                  <i className="fas fa-tasks"></i>
                  <span>المهام</span>
                </NavLink>
              </li>

              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/Companies">
                    <i className="fas fa-building"></i>
                    <span>الشركات</span>
                  </NavLink>
                </li>
              )}
              {(role === ROLES.MANAGER || role === ROLES.OWNER) && (
                <li>
                  <NavLink to="/users">
                    <i className="fas fa-users"></i>
                    <span>المستخدمين</span>
                  </NavLink>
                </li>
              )}
              {user && (
                <>
                  <li>
                    <NavLink to="/Profile">
                      <i className="fas fa-user"></i>
                      <span>الملف الشخصي</span>
                    </NavLink>
                  </li>
                  <li className="d-none">
                    <NavLink to="/Settings">
                      <i className="fas fa-cogs"></i>
                      <span>الإعدادات</span>
                    </NavLink>
                  </li>
                  <div className="text-center">
                    <button className="btn btn-secondary" onClick={() => dispatch(logoutUser())}>
                      تسجيل الخروج
                    </button>
                  </div>
                </>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
}
